import { Button } from '~/components/elements/Button'
import { ThumbUpIcon } from '~/components/icons/generated/ThumbUpIcon'

type Props = {
  likeCount: number
  onButtonClick: () => void
}
export const LikeButtonForPc: React.FC<Props> = ({
  likeCount,
  onButtonClick,
}) => {
  return (
    <Button color="outlined" onClick={onButtonClick} fitWidth>
      <span className="flex min-w-[64px] items-center justify-center gap-[5px] px-2 py-[9px]">
        <ThumbUpIcon className="h-[21px]" />
        <span className="text-[15px] font-bold">{likeCount}</span>
      </span>
    </Button>
  )
}
